import React from 'react'
import PropTypes from 'prop-types'
import HelpOption from '../../molecules/HelpOption'
import { AlertTriangle, HelpCircle } from '@olxbr/ds-icons'
import Lurker from '../../../util/lurker'
import { emailNaoChegou, faleConosco } from '../../../config/staticUrl'

const lurker = new Lurker('help_modal_password')

class PasswordHelpContent extends React.Component {
  onOptionClick = (url, lurkerEvent) => () => {
    lurker.clickEvt(lurkerEvent)
    window.location.href = url

    if (this.props.onOptionClick) {
      this.props.onOptionClick()
    }
  }

  render() {
    return (
      <div>
        <span className="typo-title-medium font-semibold mb-3">Como podemos ajudar?</span>
        <HelpOption
          text="O e-mail não chegou"
          icon={<AlertTriangle size={16} />}
          compact
          onClick={this.onOptionClick(emailNaoChegou, 'email_not_received')}
        />
        <HelpOption
          text="Preciso de mais ajuda"
          icon={<HelpCircle size={16} />}
          compact
          onClick={this.onOptionClick(faleConosco, 'need_more_help')}
          last
        />
      </div>
    )
  }
}

PasswordHelpContent.propTypes = {
  onOptionClick: PropTypes.func,
}

export default PasswordHelpContent
